import { ActionType } from 'typesafe-actions';
import * as confirmLotteryRegistrationActions from './confirmLotteryRegistrationActions';
import BaseReducer, { baseInitialState} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';


export type ConfirmLotteryRegistrationGridAction = ActionType<typeof confirmLotteryRegistrationActions>;

export interface IConfirmLotteryRegistrationStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: {} };
	readonly queries: { [queryKey: string]: [] };
}

export function confirmLotteryRegistrationReducer(
	state = baseInitialState as IConfirmLotteryRegistrationStateType,
	action: ConfirmLotteryRegistrationGridAction,
) {
	const Reducer = new BaseReducer('confirmLotteryRegistrationReducer');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}

